module.exports = __webpack_public_path__ + "img/picture_viptk02.0043c10d.png";